// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Frame_wrapper__1e1SX","resizable":"Frame_resizable__3h25G","selected":"Frame_selected__2HAv4","menu":"Frame_menu__2GRlQ","menuItem":"Frame_menuItem__3TR1i"};